// import Vue from 'vue'
import { createStore } from "vuex";
// import Vuex from 'vuex'
import Cookies from "js-cookie";

// import { assetsPrefix } from '@/utils/domain'
// Vue.use(Vuex)
const KEY = "profile_pay";
export default createStore({
  state: {
    profile: JSON.parse(window.sessionStorage.getItem(KEY)),
    deviceToken: "",
  },
  getters: {
    token({ profile }) {
      return profile ? profile.token : "";
    },
    profile({ profile }) {
      return profile;
    },
    assetsPrefix() {
      return "";
    },
    getDeviceToken({ deviceToken }) {
      return deviceToken;
    },
  },
  mutations: {
    setProfile(state, { expire = 1800, ...profile } = {}) {
      console.log("payToken", profile.token, profile);
      state.profile = profile;
      if (profile.token) {
        window.sessionStorage.setItem(KEY, JSON.stringify(profile));
        Cookies.set("web_pay_token", profile.token, {
          expires: expire / (24 * 3600),
        });
      } else {
        window.sessionStorage.removeItem(KEY);
        Cookies.remove("web_pay_token");
      }
    },
    SET_DEVICETOKEN(state, token) {
      // console.log(token, 'oo')
      state.deviceToken = token || "";
    },
  },
  actions: {
    getToken() {
      return Cookies.get("web_pay_token") || "";
    },
    setProfile(context) {
      context.commit("setProfile");
    },
    getProfile(context) {
      return context.state.profile || "";
    },
  },
});
